(function () {
  'use strict';

  var section = document.querySelector('.collection-grid-section');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var isLoading = false;

  function showSkeleton() {
    var results = document.getElementById('cg-results');
    if (!results) return;
    var count = Math.max(results.querySelectorAll('.collection-card').length, 8);
    var cards = '';
    for (var index = 0; index < count; index++) {
      cards += '<div class="collection-card collection-card--skeleton">'
        + '<div class="collection-card__media"></div>'
        + '<div class="collection-card__info">'
        + '<div class="skeleton-line skeleton-line--title"></div>'
        + '<div class="skeleton-line skeleton-line--price"></div>'
        + '</div></div>';
    }
    results.innerHTML = '<div class="grid-collections">' + cards + '</div>';
  }

  function loadPage(url) {
    if (!document.getElementById('cg-results')) return;
    if (isLoading) return;
    isLoading = true;
    section.classList.add('is-loading');
    showSkeleton();

    var fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set('sections', sectionId);

    fetch(fetchUrl.toString())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.getElementById('cg-results');
        var oldResults = document.getElementById('cg-results');
        if (newResults && oldResults) oldResults.replaceWith(newResults);

        history.pushState(null, '', url.toString());
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function () {})
      .finally(function () {
        isLoading = false;
        section.classList.remove('is-loading');
      });
  }

  section.addEventListener('click', function (event) {
    var link = event.target.closest('#cg-results .pagination__btn, #cg-results .pagination__page[href]');
    if (!link) return;
    event.preventDefault();
    loadPage(new URL(link.href));
  });

  window.addEventListener('popstate', function () {
    if (window.location.hash) return;
    loadPage(new URL(window.location.href));
  });
})();
